import React from "react";

import { useFormikContext } from "formik";

import { EngineEnum } from "../../../../../enums/engine";
import { Template } from "../../../../../models";

import InfoTooltip from "../../../../../components/common/InfoTooltip";

// these models reject the `temperature` param outright (400 error) - see gen/core/anthropic_core.py
// note: `template.temperature` is NOT NULL in the DB, so we only hide the control here -
// we never null out the field, the backend already omits it from the API call for these engines
const NO_TEMPERATURE_ENGINES = new Set([
  EngineEnum.CLAUDE_SONNET_5,
  EngineEnum.CLAUDE_OPUS_5,
]);

export default function CreativityLevelSelector() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  const isUnsupported = NO_TEMPERATURE_ENGINES.has(
    values?.engineId as EngineEnum
  );

  if (isUnsupported) return null;

  return (
    <div>
      <label
        htmlFor="temperature"
        className="mb-1 flex items-center gap-2 uppercase text-xs tracking-wide font-medium leading-6 text-gray-900"
      >
        Level of Creativity
        <InfoTooltip
          id="creativity"
          tooltip="The level of creativity will somewhat control the randomness of the text generated. A minimal creativity makes the output more deterministic and focused. A high creativity results in more diverse and creative output which can also be, at times, unpredictable."
        />
      </label>
      <div className="relative mb-6 w-96">
        <input
          id="labels-range-input"
          type="range"
          step="0.1"
          min="0.2"
          max="0.9"
          name="temperature"
          value={values?.temperature}
          onChange={({ target: { value } }) =>
            setFieldValue("temperature", value)
          }
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
        />
        <span className="text-sm text-gray-500 absolute start-0 -bottom-6">
          Minimal
        </span>
        <span className="text-sm text-gray-500 absolute start-1/3 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">
          Basic
        </span>
        <span className="text-sm text-gray-500 absolute start-2/3 -translate-x-1/2 rtl:translate-x-1/2 -bottom-6">
          Moderate
        </span>
        <span className="text-sm text-gray-500 absolute end-0 -bottom-6">
          High
        </span>
      </div>
    </div>
  );
}
